export const BRAND_LIST_QUERY_KEY = ["brands"];
